@switch (specificTemplateName) {
  @case ('plannedActivityUsers') {
    <app-planned-activity-user-template
      [columnName]="columnName"
      [element]="element"
    ></app-planned-activity-user-template>
  }
  @case ('paxOverview') {
    <app-pax-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-pax-template>
  }
  @case ('paxOnBoard') {
    <app-pax-on-board-template
      [columnName]="columnName"
      [element]="element"
    ></app-pax-on-board-template>
  }
  @case ('trips') {
    <app-trips-template [columnName]="columnName" [element]="element"></app-trips-template>
  }
  @case ('tripCrewMembers') {
    <app-trip-crew-members-template
      [columnName]="columnName"
      [element]="element"
    ></app-trip-crew-members-template>
  }
  @case ('tripPaxes') {
    <app-trip-paxes-template
      [columnName]="columnName"
      [element]="element"
    ></app-trip-paxes-template>
  }
  @case ('adminLog') {
    <app-planned-activity-admin-log-template
      [columnName]="columnName"
      [element]="element"
    ></app-planned-activity-admin-log-template>
  }
  @default {
    <app-crew-management-user-template
      [columnName]="columnName"
      [element]="element"
    ></app-crew-management-user-template>
  }
}
